import React from "react";

export const dimension = {
    height: window.innerHeight,
    width: window.innerWidth,
    vertical: window.innerWidth > window.innerHeight
}

export const DimensionContext = React.createContext(dimension)